import { render, staticRenderFns } from "./DiscussionBoardPostItem.vue?vue&type=template&id=786a0180&"
import script from "./DiscussionBoardPostItem.vue?vue&type=script&lang=js&"
export * from "./DiscussionBoardPostItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports